import { DetectionClass } from "@/constants/terminal/detection-class"

// Per-tier detection text colors, shared by the company list header (sort
// buttons) and the rows (count cells). The header pairs each color with a
// matching hover variant so the button keeps its tint on hover; rows use the
// base color alone.
const DETECTION_TEXT_CLASSES = {
  sparks: "text-detection-spark",
  smoke: "text-detection-smoke",
  fire: "text-detection-fire",
} as const

export const DETECTION_TEXT_HOVER_CLASSES = {
  sparks: "text-detection-spark hover:text-detection-spark",
  smoke: "text-detection-smoke hover:text-detection-smoke",
  fire: "text-detection-fire hover:text-detection-fire",
} as const

export const detectionTextClassByClass: Record<DetectionClass, string> = {
  [DetectionClass.SPARK]: DETECTION_TEXT_CLASSES.sparks,
  [DetectionClass.SMOKE]: DETECTION_TEXT_CLASSES.smoke,
  [DetectionClass.FIRE]: DETECTION_TEXT_CLASSES.fire,
}
